import React, { FC } from 'react';

type InfoBoxColor = 'blue' | 'green' | 'purple'

interface InfoBoxProps {
  icon: string
  children: React.ReactNode
  color?: InfoBoxColor
}

const COLOR_VARIANTS: Record<
  InfoBoxColor,
  { container: string; text: string }
> = {
  blue: {
    container: 'bg-blue-50 border-blue-200',
    text: 'text-blue-800',
  },
  green: {
    container: 'bg-green-50 border-green-200',
    text: 'text-green-800',
  },
  purple: {
    container: 'bg-purple-50 border-purple-200',
    text: 'text-purple-800',
  },
};

const InfoBox: FC<InfoBoxProps> = ({
  icon,
  children,
  color = 'blue',
}) => {
  const variant = COLOR_VARIANTS[color];

  return (
    <div
      className={`
        flex gap-3 px-4 py-3.5 rounded-lg border mb-3
        ${variant.container}
      `}
    >
      <span
        className="text-lg flex-shrink-0 mt-px"
        aria-hidden="true"
      >
        {icon}
      </span>
      <p
        className={`
          m-0 text-sm leading-relaxed ${variant.text}
        `}
      >
        {children}
      </p>
    </div>
  );
};

export default InfoBox;
